export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',

  // Amazon SP-API Integration Module
  'menu.amazon': 'Amazon',
  'menu.amazon.dashboard': 'Dashboard',
  'menu.amazon.credentials': 'Credentials',
  'menu.amazon.credentials.list': 'Credentials List',
  'menu.amazon.credentials.create': 'Create Credential',
  'menu.amazon.credentials.edit': 'Edit Credential',
  'menu.amazon.credentials.detail': 'Credential Detail',
  'menu.amazon.orders': 'Orders',
  'menu.amazon.orders.list': 'Orders List',
  'menu.amazon.orders.detail': 'Order Detail',
  'menu.amazon.sync': 'Synchronization',
  'menu.amazon.sync.status': 'Sync Status',
  'menu.amazon.sync.errors': 'Sync Errors',
  'menu.amazon.sync.history': 'Sync History',
  'menu.amazon.monitoring': 'Monitoring',
  'menu.amazon.monitoring.overview': 'Overview',
  'menu.amazon.monitoring.api-usage': 'API Usage',
  'menu.amazon.monitoring.performance': 'Performance',
  'menu.amazon.monitoring.alerts': 'Alerts',

  // Temporary fix for duplicate key names
  'menu.amazon.amazon.sync.amazon.sync.status': 'Sync Status',
  'menu.amazon.amazon.monitoring.amazon.monitoring.alerts': 'Alerts',
};
